<div class="d-flex align-items-center">
    <mat-chip-list [attr.aria-label]="'Payable Status'">
        <mat-chip [ngClass]="statusClass"
                  (click)="statusClicked.emit()"
                  selected>
            <span class="status-content">
                <span>{{ payable.statusDescription }}</span>
            </span>
        </mat-chip>
    </mat-chip-list>
    <i
        *ngIf="!!errorMessage"
        [matTooltip]="errorMessage"
        [matTooltipPosition]="'above'"
        class="fa fa-exclamation-circle error-icon ml-1 text-danger"
        aria-hidden="true">
    </i>
</div>
